import React from 'react';

type SecureDashboardCardProps = {
  title: string;
  value?: string | number;
  isVisible: boolean;
  onReveal: () => void;
};

const SecureDashboardCard: React.FC<SecureDashboardCardProps> = ({ title, value, isVisible, onReveal }) => {
  return (
    <div
      className="bg-white shadow rounded p-6 flex flex-col gap-2 h-48 w-64 cursor-pointer hover:shadow-lg transition-shadow"
      onClick={onReveal}
    >
      <h2 className="text-base font-medium text-gray-600">{title}</h2>
      <div className="flex items-center justify-center flex-1">
        {isVisible ? (
          <p className="text-3xl font-bold text-gray-900">{value}</p>
        ) : (
          <div className="flex flex-col items-center gap-2">
            <span className="material-icons text-4xl text-gray-400">lock</span>
            <p className="text-sm text-gray-500 text-center">Click to reveal</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SecureDashboardCard;